<template>
  <div class="space-y-8 text-center">
    <div class="space-y-4">
      <p class="text-base-content/70 leading-relaxed">
        {{ t("smartLeadForm.planReady.description") }}
      </p>
    </div>

    <button
      @click="onComplete"
      class="btn btn-primary btn-lg w-full rounded-xl font-medium"
      :aria-label="t('smartLeadForm.planReady.ctaLabel')">
      {{ t("smartLeadForm.planReady.cta") }}
    </button>

    <p class="text-sm text-base-content/50 font-medium">
      {{ t("smartLeadForm.planReady.note") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits(["complete"]);

function onComplete() {
  emit("complete");
}
</script>
